import React from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import { Cell } from "fixed-data-table-2"

// helper functions
import { cleanUpHtml } from "imports/desktopHelperFunctions"

export const CommitteeDatumCell = props => (
    <Cell
        {...props}
    >
        {
            cleanUpHtml(
                props.datum.get(DjangIO.app.models.QuorumDataType.dashboard.display_key)
            )
        }
        {
            props.datum.get("parent_committee_name") && (
                ` (${props.datum.get("parent_committee_name")})`
            )
        }
    </Cell>
)
CommitteeDatumCell.propTypes = {
    datum: PropTypes.object.isRequired,
}

export default CommitteeDatumCell
